
import { assign } from '../common/utils';

const initialState = {
    loading: false,
    label: 0,
    userPin: null,
    cur_city: { cityId: 11, cityName: '北京', cityPy: 'bj', fullCityPy: 'beijing', letter: 'b' },
    lbsCity: null, // {cityId:31,cityName:'上海',cityPy:'sh',fullCityPy:'shanghai',letter:'s'}
    lbs: null
};

const index = (state = initialState, action) => {
    switch (action.type) {
        case 'change_label':
            return assign(state, {
                label: action.label
            });

        case 'userPin':
            return assign(state, {
                userPin: action.userPin
            });

        case 'cur_city':
            return assign(state, {
                cur_city: action.cur_city
            });

        case 'lbsCity':
            return assign(state, {
                lbsCity: action.lbsCity
            });

        case 'lbs':
            return assign(state, {
                lbs: action.lbs
            });

        default:
            return state;
    };
};

export default index;
